module.exports = "/_next/static/images/bf96874a1790a2bf2153d6ab1916e4b8-people-working-together@xs-2x.jpg.webp";